import { z } from "zod";
/** Строка `vehicles_clients` (автомобиль клиента) — для выбора в форме заказа (WP-DSP-FIX-02, D31б). */
export const zClientVehicleRowDto = z.object({
    id: z.string(),
    idClient: z.string(),
    brand: z.string().nullish(),
    model: z.string().nullish(),
    stateNumber: z.string().nullish(),
    color: z.string().nullish(),
    isActive: z.boolean().nullish(),
});
export const CLIENT_VEHICLE_COLUMNS = "id,idClient,brand,model,stateNumber,color,isActive";
